import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { BsInfoCircleFill } from "react-icons/bs";

export const CompilaQuestionarioKpisValoriEsempio = (props) => {
    let rowsSet = props.helpRowsObjectArray
    return (
        <Card style={{marginBottom:"1%"}}>
            <Card.Title as='h6' style={{marginTop:"1%", marginLeft:"1%"}}>
                <h6 className="text-primary  mb-0"><BsInfoCircleFill  class="fa fa-question-circle fa-lg" /><em>&nbsp;&nbsp;&nbsp;Un suggerimento:</em></h6>
            </Card.Title>
            <Card.Body>
            
                <Card.Text> 


                {rowsSet.map((rigaEsempio) => (
                        <><p className="text-primary  mb-0">
                          {rigaEsempio.text}<br />       
                          </p></>
                ))}
                </Card.Text> 


            </Card.Body>
        </Card>
    );
};

CompilaQuestionarioKpisValoriEsempio.propTypes = {
    helpRowsObjectArray: PropTypes.array
};

/*
                    {props.helpRowsObjectArray.map((rigaEsempio) => (
                        <>
                          <p>{rigaEsempio.row}</p>       
                        </>
                    ))}



                    {props.formula_A_Qta_Valore}{' '}{props.formula_A_Qta_UM} <i>({props.formula_A_Qta_Label})</i><br />
                    {' x '}{props.formula_B_ValoreUnit_Importo} {props.formula_B_ValoreUnit_UM} <i>({props.formula_B_ValoreUnit_Label})</i><br />
                    {' = '}{props.formula_C_ValoreTot_Importo} {props.formula_C_ValoreTot_UM} <i>({props.formula_C_ValoreTot_Label})</i>



            <Row className="g-0">
                <Col xs={6} md={2} className='border-200 border-md-200 border-bottom border-md-bottom-0 border-md-end pt-4 pb-md-0 ps-3 ps-md-0'>
                <br /><p className="font-sans-serif lh-1 mb-1 fs-7">{props.annoCorrente}</p>
                </Col>
                <Col xs={6} md={6} className='border-200 border-bottom border-end pb-4'>
                <br /><p className="font-sans-serif lh-1 mb-1 fs-9">{props.annoCorrente}</p>
                </Col>
                <Col xs={6} md={4} className='border-200 border-bottom border-end pb-4'>
                <br /><p className="font-sans-serif lh-1 mb-1 fs-12">{props.annoCorrente}</p>
                </Col>
            </Row>
            <Row className="g-0">
                <Col xs={6} md={2} className='border-200 border-md-200 border-bottom border-md-bottom-0 border-md-end pt-4 pb-md-0 ps-3 ps-md-0'>
                <br /><p className="font-sans-serif lh-1 mb-1 fs-7">{props.annoSuccessivo}</p>
                </Col>
                <Col xs={6} md={6} className='border-200 border-md-bottom-0 border-end pt-4 pb-md-0 ps-md-3'>
                <br /><p className="font-sans-serif lh-1 mb-1 fs-9">{props.annoSuccessivo}</p>
                </Col>
                <Col xs={6} md={4} className='pb-0 pt-4 ps-3'>
                <br /><p className="font-sans-serif lh-1 mb-1 fs-12">{props.annoSuccessivo}</p>
                </Col>
            </Row>

*/